.badge {
  position: fixed;
  bottom: 12px;
  right: 12px; /* the Logbook bottom bar keeps its controls (Events, compact mode) on the left */
  color: var(--fully-white);
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  z-index: 99999;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: none;
}

.badge:hover {
  opacity: 1;
}

.local {
  background-color: #22c55e;
}

.staging {
  background-color: #f59e0b;
}

.production {
  background-color: #ef4444;
}
